import React from 'react';
export function Terms() {
  return <div className="min-h-screen bg-gradient-to-b from-white to-slate-50" data-id="element-488">
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-489">
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8" data-id="element-490">
          Terms & Conditions
        </h1>

        <div className="bg-white rounded-2xl shadow-lg p-8 space-y-6" data-id="element-491">
          <div data-id="element-492">
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-493">
              <strong data-id="element-494">Last updated:</strong>{' '}
              {new Date().toLocaleDateString('en-GB', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>
            <p className="text-slate-600 leading-relaxed" data-id="element-495">
              These Terms & Conditions ("Terms") govern your use of Domisafe and
              the services we provide. By accessing or using our platform, you
              agree to be bound by these Terms. Please read them carefully.
            </p>
          </div>

          <div data-id="element-496">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-497">
              1. Website Ownership and Operation
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-498">
              This website and the Domisafe platform are owned and operated by
              Domisafe. All content, features, and functionality are the
              property of Domisafe and are protected by copyright, trademark,
              and other intellectual property laws.
            </p>
          </div>

          <div data-id="element-499">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-500">
              2. Service Description
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-501">
              Domisafe provides cloud-based software for managing customer
              information, tracking tasks, sending updates, and monitoring
              performance. Our service is delivered on a subscription basis and
              accessed via your web browser.
            </p>
            <p className="text-slate-600 leading-relaxed" data-id="element-502">
              We reserve the right to modify, suspend, or discontinue any aspect
              of the service at any time, with or without notice. We will make
              reasonable efforts to notify users of significant changes.
            </p>
          </div>

          <div data-id="element-503">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-504">
              3. Subscription and Account
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-505">
              To use Domisafe, you must create an account and purchase a
              subscription. You agree to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-600" data-id="element-506">
              <li data-id="element-507">
                Provide accurate, current, and complete information during
                registration
              </li>
              <li data-id="element-508">Maintain the security of your account credentials</li>
              <li data-id="element-509">
                Notify us immediately of any unauthorised use of your account
              </li>
              <li data-id="element-510">
                Accept responsibility for all activities that occur under your
                account
              </li>
            </ul>
            <p className="text-slate-600 leading-relaxed mt-4" data-id="element-511">
              You must be at least 18 years old to create an account and use our
              service.
            </p>
          </div>

          <div data-id="element-512">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-513">
              4. Subscription Rules
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-514">
              Subscriptions are billed monthly on the date you first subscribed.
              By purchasing a subscription, you authorise us to charge your
              payment method automatically each month until you cancel.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-515">
              You may upgrade, downgrade, or cancel your subscription at any
              time. Changes to your subscription take effect at the start of the
              next billing cycle. Cancellations and refunds are subject to our
              Cancellation Policy and Refund Policy.
            </p>
            <p className="text-slate-600 leading-relaxed" data-id="element-516">
              We reserve the right to change our pricing at any time. If we
              increase the price of your subscription, we will notify you at
              least 30 days in advance. Continued use of the service after a
              price change constitutes acceptance of the new price.
            </p>
          </div>

          <div data-id="element-517">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-518">
              5. Payment Terms
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-519">
              All payments are processed securely through Stripe. You agree to
              provide valid payment information and authorise us to charge your
              payment method for all fees incurred.
            </p>
            <p className="text-slate-600 leading-relaxed" data-id="element-520">
              If a payment fails, we will attempt to contact you and may suspend
              your access to the service until payment is received. Repeated
              payment failures may result in account termination.
            </p>
          </div>

          <div data-id="element-521">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-522">
              6. User Responsibilities
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-523">
              As a user of Domisafe, you are responsible for:
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-600" data-id="element-524">
              <li data-id="element-525">
                Ensuring your use of the service complies with all applicable
                laws and regulations
              </li>
              <li data-id="element-526">
                The accuracy and legality of any data you upload or store on the
                platform
              </li>
              <li data-id="element-527">Maintaining appropriate backups of your data</li>
              <li data-id="element-528">
                Protecting the confidentiality of your account credentials
              </li>
              <li data-id="element-529">
                Using the service in a manner that does not harm Domisafe or
                other users
              </li>
            </ul>
          </div>

          <div data-id="element-530">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-531">
              7. Acceptable Use
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-532">
              You agree not to use Domisafe for any unlawful or prohibited
              purpose, including but not limited to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-600" data-id="element-533">
              <li data-id="element-534">Violating any laws or regulations</li>
              <li data-id="element-535">Infringing on the intellectual property rights of others</li>
              <li data-id="element-536">Transmitting harmful code, viruses, or malware</li>
              <li data-id="element-537">
                Attempting to gain unauthorised access to our systems or other
                users' accounts
              </li>
              <li data-id="element-538">
                Using the service to send spam or unsolicited communications
              </li>
              <li data-id="element-539">Interfering with the proper functioning of the platform</li>
              <li data-id="element-540">
                Engaging in any activity that could damage our reputation or
                business
              </li>
            </ul>
            <p className="text-slate-600 leading-relaxed mt-4" data-id="element-541">
              We reserve the right to suspend or terminate your account if we
              believe you have violated these acceptable use provisions.
            </p>
          </div>

          <div data-id="element-542">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-543">
              8. Data Protection
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-544">
              We are committed to protecting your personal data in accordance
              with UK data protection law, including the General Data Protection
              Regulation (GDPR). Please refer to our Privacy & Cookie Policy for
              detailed information about how we collect, use, and protect your
              data.
            </p>
          </div>

          <div data-id="element-545">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-546">
              9. Intellectual Property
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-547">
              All content, features, and functionality of Domisafe, including
              but not limited to text, graphics, logos, software, and design,
              are owned by Domisafe and protected by copyright, trademark, and
              other intellectual property laws.
            </p>
            <p className="text-slate-600 leading-relaxed" data-id="element-548">
              You are granted a limited, non-exclusive, non-transferable licence
              to access and use the service for your business purposes. You may
              not copy, modify, distribute, sell, or reverse engineer any part
              of our service without our express written permission.
            </p>
          </div>

          <div data-id="element-549">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-550">
              10. Limitations of Liability
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-551">
              To the fullest extent permitted by law, Domisafe shall not be
              liable for any indirect, incidental, special, consequential, or
              punitive damages arising from your use of or inability to use the
              service, including but not limited to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-600" data-id="element-552">
              <li data-id="element-553">Loss of profits, revenue, or business opportunities</li>
              <li data-id="element-554">Loss of data or information</li>
              <li data-id="element-555">Business interruption</li>
              <li data-id="element-556">Any other commercial damages or losses</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mt-4" data-id="element-557">
              Our total liability to you for any claims arising from your use of
              the service shall not exceed the amount you paid for your
              subscription in the 12 months preceding the claim.
            </p>
            <p className="text-slate-600 leading-relaxed mt-4" data-id="element-558">
              We make no warranties or representations about the accuracy,
              reliability, or completeness of the service. The service is
              provided "as is" and "as available" without warranties of any
              kind, either express or implied.
            </p>
          </div>

          <div data-id="element-559">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-560">
              11. Indemnification
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-561">
              You agree to indemnify, defend, and hold harmless Domisafe, its
              officers, directors, employees, and agents from any claims,
              liabilities, damages, losses, or expenses (including legal fees)
              arising from your use of the service, your violation of these
              Terms, or your violation of any rights of another party.
            </p>
          </div>

          <div data-id="element-562">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-563">
              12. Dispute Resolution
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-564">
              These Terms are governed by the laws of England and Wales. Any
              disputes arising from these Terms or your use of Domisafe shall be
              subject to the exclusive jurisdiction of the courts of England and
              Wales.
            </p>
            <p className="text-slate-600 leading-relaxed" data-id="element-565">
              Before initiating any legal proceedings, we encourage you to
              contact us to attempt to resolve the dispute informally. Many
              disputes can be resolved quickly and amicably through direct
              communication.
            </p>
          </div>

          <div data-id="element-566">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-567">
              13. Termination
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-568">
              We reserve the right to suspend or terminate your account and
              access to the service at any time, with or without cause, and with
              or without notice. Reasons for termination may include:
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-600" data-id="element-569">
              <li data-id="element-570">Violation of these Terms</li>
              <li data-id="element-571">Fraudulent or illegal activity</li>
              <li data-id="element-572">Non-payment of fees</li>
              <li data-id="element-573">Behaviour that harms Domisafe or other users</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mt-4" data-id="element-574">
              Upon termination, your right to use the service will cease
              immediately. We may delete your data in accordance with our data
              retention policies.
            </p>
          </div>

          <div data-id="element-575">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-576">
              14. Changes to These Terms
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-577">
              We may update these Terms from time to time to reflect changes in
              our service, legal requirements, or business practices. We will
              notify you of any significant changes by email or through a notice
              on our platform. Your continued use of Domisafe after such changes
              constitutes acceptance of the updated Terms.
            </p>
          </div>

          <div data-id="element-578">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-579">
              15. Severability
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-580">
              If any provision of these Terms is found to be invalid or
              unenforceable, the remaining provisions shall continue in full
              force and effect. The invalid or unenforceable provision shall be
              replaced with a valid provision that most closely reflects the
              intent of the original provision.
            </p>
          </div>

          <div data-id="element-581">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-582">
              16. Entire Agreement
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-583">
              These Terms, together with our Privacy & Cookie Policy,
              Cancellation Policy, and Refund Policy, constitute the entire
              agreement between you and Domisafe regarding your use of the
              service and supersede any prior agreements or understandings.
            </p>
          </div>

          <div data-id="element-584">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-585">
              17. Contact Information
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-586">
              If you have any questions about these Terms & Conditions, please
              contact us at:
            </p>
            <p className="text-slate-600 mt-4" data-id="element-587">
              <strong data-id="element-588">Email:</strong>{' '}
              <a href="mailto:hubtut84@gmail.com" className="text-emerald-600 hover:text-emerald-700 font-medium" data-id="element-589">
                hubtut84@gmail.com
              </a>
            </p>
          </div>

          <div className="bg-slate-50 rounded-lg p-6 mt-8" data-id="element-590">
            <p className="text-slate-700 leading-relaxed" data-id="element-591">
              <span className="font-semibold" data-id="element-592">
                By using Domisafe, you acknowledge that you have read,
                understood, and agree to be bound by these Terms & Conditions.
              </span>
            </p>
          </div>
        </div>
      </section>
    </div>;
}